import BossModel from "@/models/BossModel";
import User from "@/models/User/User";

export default class PriceExtension extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/price-extension';

    /**
     *
     * @type {string}
     */
    static entity = 'productPriceExtension';

    static fields() {
        return {
            id: this.number(null).nullable(),
            user_id: this.number(),
            start_date: this.attr(),
            end_date: this.attr(),
            reverted_at: this.attr(),
            is_allowance_extended: this.boolean(),
            is_discount_extended: this.boolean(),
            is_purchase_extended: this.boolean(),
            is_period_allowance_extended: this.boolean(),
            purchase_modifier: this.number(),
            elements_count: this.number(),
            finished_elements_count: this.number(),
            country: this.attr(null),
            created_at: this.attr(),
            user: this.belongsTo(User, 'user_id'),
        }
    }

    get purchaseModifierPercentage() {
        return ((this.purchase_modifier - 1) * 100).toFixed(0);
    }

    get percentageFinished() {
        return (this.finished_elements_count / this.elements_count) * 100;
    }

    revert() {
        return this.constructor.api()
            .action(`${this.id}/revert`)
            .update();
    }
}
